// see https://developers.google.com/identity/sign-in/web/build-button
var auth2;

function initGoogleSignin() {
    try {
        var hash = window.location.hash.substring(1);
        
        if (hash.indexOf('id_token') != -1) {
            var start = hash.indexOf('=');
            if (start !== -1) {
                var idToken = getIDToken(hash);
                setTimeout(function() {
                    googlelogin(idToken);
                }, 200);
                
            }
        } else {
        	var isIE = false || !!document.documentMode
        	if(isIE) {
        		document.getElementById('gSignInBtn').style.backgroundColor = '#EEEEEE';
        		return;
        	}
            gapi.load('auth2', function(){
                auth2 = gapi.auth2.init({
                    client_id: '889223543345-g564lvsqo75nahnqsr349viskj4tpeok.apps.googleusercontent.com',
                    cookiepolicy: 'single_host_origin',
                    ux_mode: 'redirect'
                });

                var signInBtn = document.getElementById('gSignInBtn');
                if (signInBtn) {
                    setCookie('urlHash', window.location.hash);
                    if (getCookie('googleSignIn') === 'true' && getCookie('manualLogout') !== 'true') {
                        auth2.signIn().then(function() {
                            userChanged(auth2.currentUser.get());
                        });
                    }
                    attachSignin(signInBtn);
                }
            });
        }
    } catch (e) {
    }
}

function getIDToken(hash) {
	var subHash = hash.substring(hash.indexOf('id_token='))
	var idToken = subHash.substring(subHash.indexOf('=') + 1, subHash.indexOf('&'))
	return idToken
}

function userChanged(googleUser) {
    deleteCookie('manualLogout');
    googlelogin(googleUser.getAuthResponse().id_token);
}

function attachSignin(element) {
    auth2.attachClickHandler(element, {},
        userChanged,
        function(error) {
            console.log('Error in signin: ' + JSON.stringify(error));
        });
}

function googleSignOut() {
    try {
        setCookie('manualLogout', 'true');
        if (gapi && gapi.auth2) {
            var auth2 = gapi.auth2.getAuthInstance();
            if (auth2) {
                if (auth2.isSignedIn.get()) {
                    auth2.signOut().then(function () {

                        //console.log('User signed out.');
                    });
                }
            }
        }
    } catch (e) {
    }
}
